import styled, { css } from 'styled-components';
import { IProgressBarFragment } from './types';

export const CurrentStep = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.regular};
  color: ${({ theme }) => theme.baseColors.base100};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`;

export const NextStep = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.small};
  color: ${({ theme }) => theme.baseColors.base50};
`;

export const ProgressBarFragment = styled.li<IProgressBarFragment>`
  border-radius: 2px;
  height: 3px;
  background-color: ${({ theme }) => theme.baseColors.base15};
  margin: 0 -3px;
  list-style: none;

  ${({ index, currentStep }) =>
    index <= currentStep
      ? css`
          background-color: ${({ theme }) => theme.colors.secondary};
        `
      : null}
`;

export const ProgressBarFragmentText = styled.span`
  position: absolute !important;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
`;
